<template>
  <ul class="accessory-list">
    <li :key="accessory.id" v-for="accessory in accessories">
      <router-link :to="`/accessory/${accessory.id}`">{{capitalize(accessory.name)}}</router-link>
    </li>
  </ul>
</template>

<script>
import { capitalize } from '../../utils/helpers'

export default {
  name: 'PonyAccessories',
  props: {
    accessories: {
      type: Array,
      required: true
    }
  },
  methods: {
    capitalize
  }
}
</script>

<style lang="scss" scoped>
.accessory-list {
  list-style: none;
  margin-bottom: 40px;
  padding-left: 0;

  li {
    padding: 0;
    margin: 5px 0;
  }
}
</style>
